export const RUN_STATUS = {
  hesaplandi: ["Hesaplandı", "bg-sky-50 text-sky-700 border-sky-200"],
  yonetici_onayi: ["Yönetici Onayında", "bg-amber-50 text-amber-800 border-amber-200"],
  onaylandi: ["Onaylandı", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  kismen_odendi: ["Kısmen Ödendi", "bg-violet-50 text-violet-700 border-violet-200"],
  odendi: ["Ödendi", "bg-slate-900 text-white border-slate-900"],
  reddedildi: ["Reddedildi", "bg-rose-50 text-rose-700 border-rose-200"],
  yerine_gecti: ["Yeni Versiyonla Değişti", "bg-slate-100 text-slate-500 border-slate-200"],
  hesaplanmadi: ["Hesaplanmadı", "bg-white text-slate-500 border-dashed border-slate-300"],
  pasif: ["Pasif", "bg-slate-100 text-slate-400 border-slate-200"],
};

export const RunBadge = ({ status, testid }) => {
  const [label, cls] = RUN_STATUS[status] || [status, ""];
  return <span className={`text-[11px] font-medium px-1.5 py-0.5 rounded border whitespace-nowrap ${cls}`} data-testid={testid}>{label}</span>;
};

export const RANGES = [["today", "Bugün"], ["week", "Bu Hafta"], ["month", "Bu Ay"], ["last_month", "Geçen Ay"], ["year", "Bu Yıl"]];

export const Pill = ({ active, onClick, children, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`h-8 px-3 text-[12px] rounded-full border transition-colors ${active ? "bg-slate-900 text-white border-slate-900" : "bg-white border-slate-200 hover:border-blue-600"}`}>{children}</button>
);

export const has = (o, k) => o && Object.prototype.hasOwnProperty.call(o, k);
